<template>
  <admin-wrapper :straight-title="additionalModuleName" :module-enabler="moduleEnabler" :inputs="inputs" />
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'SearchAreaSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules@OZE_SEARCH_MODULE.verbose_name'),
    moduleEnabler() {
      return {
        name: 'oze_search_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'oze_search_module_api_address',
          translationPath: 'admin.apiAdress',
          dataType: { name: 'text' },
          clearable: true,
          rules: [v => !!v || v == '0' || 'rules.required'],
        },
      ];
    },
  },
};
</script>
